"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TENANTS = void 0;
/**
 * Active tenants — mirrors TenantUtil.getTenants() (excludes ALASU, TULSA, UADL, AUB, GWU, DU).
 */
exports.TENANTS = [
    { id: '6ee0a15f-da90-4433-a91c-b661af3f3a24', code: 'SCU', name: 'Santa Clara University' },
    { id: '67da7acf-3f4e-4e9a-85d5-f6210cac527e', code: 'TULANE', name: 'Tulane University' },
    { id: '92a9be7c-6b69-4066-b131-b503b2c4838d', code: 'KU', name: 'University of Kansas' },
    { id: '835b1dfd-d563-4006-873e-14819cd7d6e8', code: 'CSUMB', name: 'California State University at Monterey Bay' },
    { id: 'a5998b86-b890-4127-8ec0-49797dd091f7', code: 'CWRU', name: 'Case Western Reserve University' },
    { id: 'c27e4f70-81dd-4036-a4af-f0f93c6b3286', code: 'WM', name: 'College of William & Mary' },
    { id: 'e8f56d1e-22e4-4960-9532-f031c2a4258e', code: 'KSU', name: 'Kent State University' },
    { id: '6c8f545d-f3ce-45ce-af68-e4726e456f82', code: 'PITT', name: 'University of Pittsburgh' },
    { id: 'b75fd532-9fcc-420a-9772-bfe4c2b4b2b8', code: 'YU', name: 'Yeshiva University' },
    { id: '56fe1cbb-617d-449d-abae-ac78f981311a', code: 'CHICO', name: 'California State University at Chico' },
    { id: '7d70fcc4-8a51-4768-a00d-e884cee2bdb5', code: 'MARQUETTE', name: 'Marquette University' },
    { id: '106bee39-9360-4b35-9415-2cc2b604322f', code: 'NU', name: 'Northwestern University' },
    { id: 'a07f0a3e-3096-4fda-bf74-dd1cfdb28cd3', code: 'SEATTLE', name: 'Seattle University' },
    { id: '70a11cdc-8199-4356-8062-052e3ce57df8', code: 'OKCU', name: 'Oklahoma City University' },
];
